import {styled} from '../../utils';
import {padding, borderRadius} from 'polished';
import {Header} from '../Layout';

export default styled(Header)(({theme}) => ({
  fontFamily: theme.fontFamily.base,
  fontSize: 18,
  fontWeight: 700,
  boxSizing: 'border-box',
  borderBottom: '1px solid #F1F3F6',
  ...borderRadius('top', 3),
  ...padding(20, 25)
}));



// WEBPACK FOOTER //
// ./src/components/Card/CardHeader.tsx